{
  "title": "委託品の受付",
  "intro": "委託者を選び、カードを1枚ずつ入れて、最後にボタンを1回。商品ページを仕上げるまで販売はされません。",
  "load_failed": "この受付を開けませんでした。",
  "steps": {
    "label": "手順",
    "consignor": "委託者",
    "cards": "カード",
    "review": "確認して受付"
  },
  "consignor": {
    "search": "委託者を探す",
    "search_hint": "名前・カナ・CON-番号・メール",
    "results": "見つかった委託者",
    "none": "見つかりません。",
    "create": "新しい委託者を登録",
    "load_failed": "委託者を読み込めませんでした。",
    "change": "別の人",
    "location": "受け付ける店舗",
    "location_hint": "カードはこの店舗で保管し、この店舗の古物台帳に記録します。",
    "start": "受付を始める"
  },
  "block": {
    "kyc_missing": "この方の本人確認がまだです。",
    "kyc_missing_why": "古物営業法：古物を受け取る前に、必ず身分証で本人確認をします。",
    "kyc_pending": "本人確認が確認待ちです。",
    "kyc_pending_why": "先に委託者のページで確認を済ませてください（古物営業法）。",
    "kyc_expired": "この方の本人確認の有効期限が切れています。",
    "kyc_expired_why": "古物営業法：期限切れの確認は使えません。受け付ける前にもう一度本人確認をしてください。",
    "kyc_rejected": "前回の本人確認は認められませんでした。",
    "kyc_rejected_why": "古物営業法：受け付けられる身分証でもう一度本人確認をしてください。",
    "suspended": "この委託者は一時停止中です。",
    "suspended_why": "委託者のページで理由を確認し、再開してください。",
    "closed": "この委託者は終了しています。",
    "closed_why": "終了した委託者から新しいカードは受け付けられません。",
    "agreement": "最新の委託契約にまだ署名していません。",
    "agreement_why": "契約への署名は1回だけ。その後の受付はすべてこの契約で行います。",
    "do_check": "今すぐ本人確認",
    "record_agreement": "店頭で第{{version}}版に署名済み",
    "open_consignor": "委託者のページを開く"
  },
  "kinds": {
    "raw_single": "カード",
    "graded_single": "鑑定カード",
    "sealed_product": "未開封BOX"
  },
  "entry": {
    "title": "{{n}}枚目",
    "kind": "種類",
    "card": "カードをスキャン／入力",
    "title_label": "ラベルの名前",
    "title_hint": "選んだカードから入ります。必要なら直してください。",
    "quantity": "箱数",
    "quantity_hint": "1箱ごとにラベルが出ます。",
    "weight": "箱の重さ",
    "weight_hint": "商品そのもの（箱のまま）を量ってください。封筒や緩衝材は入れません — 送料の計算では店の梱包材の重さが自動で足されます。",
    "price": "合意した販売価格",
    "price_help": "お客様が払う価格（税込）。委託者と合意した金額です。",
    "agreed_min": "最低価格",
    "agreed_min_hint": "任意。これより下げるときは必ず委託者の承認が必要です。",
    "commission": "手数料",
    "commission_hint": "空欄 = {{percent}} %（この委託者の標準）",
    "commission_hint_rule": "空欄 = お店の手数料ルール",
    "company": "鑑定会社",
    "grade": "グレード",
    "cert": "鑑定番号",
    "discount": "値引きOK（10 %まで）",
    "discount_hint": "セールで最大10 %まで値引きしてよいと委託者が了承しています。",
    "photos": "写真（1〜2枚）",
    "features": "傷・特徴",
    "features_hint": "古物台帳に書きます。例：「裏面に小さな傷」",
    "add": "このカードを追加",
    "enter_hint": "Enterで追加して、次のカードへ。"
  },
  "lines": {
    "caption": "この受付のカード",
    "card": "カード",
    "condition": "状態",
    "price": "合意価格",
    "terms": "条件",
    "status": "状況",
    "remove": "削除",
    "remove_line": "{{n}}枚目を削除",
    "removed": "削除しました。",
    "empty": "まだカードがありません。下から1枚目を追加してください。",
    "min": "最低",
    "commission": "手数料 {{percent}} %",
    "commission_default": "標準の手数料",
    "discount_ok": "値引き {{percent}} %まで",
    "discount_no": "値引きなし",
    "photos_one": "写真{{count}}枚",
    "photos_other": "写真{{count}}枚",
    "weight": "{{grams}} g",
    "pending": "まだ受付前",
    "created": "受付済み",
    "failed": "受け付けられませんでした"
  },
  "problems": {
    "title": "カードの名前を入れてください。",
    "rank": "ランクA〜Dを選んでください。",
    "grading_company": "鑑定会社を選んでください。",
    "grade": "グレードを選んでください。",
    "cert": "鑑定番号を入れてください。",
    "quantity": "1〜50箱で入れてください。",
    "weight": "重さをグラムで入れてください（1〜100,000）。",
    "price": "金額を円で入れてください。",
    "agreed_min": "最低価格を円で入れてください。",
    "agreed_min_above": "最低価格が販売価格より高くなっています。",
    "commission": "0〜100の数字で入れてください。",
    "photos": "写真は10枚までです。",
    "photos_busy": "写真のアップロードが終わるまでお待ちください。",
    "reason": "理由を短く書いてください。",
    "fix_first": "赤い欄を先に直してください。"
  },
  "summary": {
    "agreement": "契約 第{{version}}版",
    "so_far_one": "ここまで{{count}}枚",
    "so_far_other": "ここまで{{count}}枚",
    "next": "確認して受付へ",
    "cards": "カード",
    "total": "合意価格の合計（税込）",
    "what_happens": "受付すると、カードごとに下書きの商品（まだ販売しない）を作り、古物台帳に受入を記録し、在庫に入れます。そのあと委託契約書／預り証（2通）とラベルを印刷します。",
    "back": "カードに戻る",
    "complete": "受付する"
  },
  "done": {
    "title_one": "{{count}}枚受け付けました。",
    "title_other": "{{count}}枚受け付けました。",
    "toast_one": "{{count}}枚受け付けました。",
    "toast_other": "{{count}}枚受け付けました。",
    "some_failed": "{{created}}枚受付済み、{{failed}}枚は受け付けられませんでした。",
    "what_happened": "古物台帳と在庫に記録済みで、まだ販売はしていません。カードを開いて商品ページを仕上げてください。",
    "retry": "残りのカードをもう一度",
    "documents": "委託契約書／預り証",
    "documents_pending": "委託契約書を作成中…",
    "documents_failed": "委託契約書がまだ作れていません。自動でやり直します。",
    "documents_unavailable": "委託契約書・預り証はまだシステムで作れません（書式の準備中）。今回は紙の書式をお渡しください — 受付そのものは保存されています。",
    "documents_todo": "やることリストを開く",
    "document_n": "書類{{n}}",
    "labels": "ラベルを印刷",
    "to_items": "このカードを見る",
    "again": "この方のカードを続けて受付",
    "ledger_one": "古物台帳に受入を{{count}}行記録しました。",
    "ledger_other": "古物台帳に受入を{{count}}行記録しました。",
    "ledger_open": "古物台帳を開く"
  },
  "cancel": {
    "button": "この受付をやめる",
    "title": "この受付をやめますか？",
    "consequence": "まだ何も受け付けていません。入力したカードは消えます。",
    "confirm": "受付をやめる",
    "done": "受付をやめました。",
    "already": "この受付は取り消されています。",
    "new": "新しい受付を始める"
  },
  "board": {
    "intro": "委託カードを状態ごとに表示します。確認・一時停止・終了はドラッグで。ほかの状態は自動で変わります。",
    "new_intake": "委託品を受け付ける",
    "drafts_one": "終わっていない受付が{{count}}件：",
    "drafts_other": "終わっていない受付が{{count}}件：",
    "draft_cards_one": "{{count}}枚",
    "draft_cards_other": "{{count}}枚",
    "views": "表示のしかた",
    "tab_board": "ボード",
    "tab_list": "表",
    "tab_prices": "価格の承認",
    "only_of": "この方のカードだけ：",
    "show_all": "全員",
    "search": "カードを探す",
    "search_hint": "名前・ラベルコード・鑑定番号",
    "drag_hint": "カードをタップすると詳細が見られます。キーボードではカードを開いてボタンを使います。",
    "locked": "自動で変わります",
    "auto_listed": "商品ページが販売中になったとき。",
    "auto_reserved": "お客様の注文で確保されている間。",
    "auto_sold": "お客様が支払ったとき。",
    "auto_returned": "委託者に返したとき。",
    "refuse_automatic": "「{{stage}}」は自動で変わります（売れたとき・販売中・返却時）。手で選ぶことはできません。",
    "refuse_not_from_here": "今の状態からは「{{stage}}」に変えられません。"
  },
  "list": {
    "reference": "ラベルコード",
    "card": "カード",
    "stage": "状態",
    "consignor": "委託者",
    "received": "受付日"
  },
  "item": {
    "title": "委託カード",
    "load_failed": "このカードを読み込めませんでした。",
    "intake": "受付 {{reference}}・{{line}}枚目",
    "price": "販売価格",
    "payout": "委託者の受取（目安）",
    "finish_product": "商品ページを仕上げる",
    "open_product": "商品ページを開く",
    "create_product": "商品をもう一度作る",
    "retried": "やり直しています。",
    "discount_title": "値引き",
    "discount": "お店が最大{{percent}} %まで値引きしてよい",
    "discount_reason": "委託カードのページで変更",
    "discount_locked": "今は委託者だけが変更できます（ポータルでの委託者の選択）。",
    "status_title": "状態",
    "moved": "「{{stage}}」にしました。",
    "notes": "メモ",
    "save_notes": "メモを保存",
    "saved": "保存しました。",
    "timeline": "履歴",
    "actor_staff": "スタッフ",
    "actor_consignor": "委託者",
    "actor_system": "自動"
  },
  "move": {
    "to": {
      "received": "「受付済み」に戻す",
      "under_review": "先に確認する",
      "ready_to_list": "販売準備OK",
      "paused": "一時停止",
      "closed": "終了"
    },
    "auto_listed": "販売中。お客様が注文・購入すると自動で変わります。",
    "auto_reserved": "お客様の注文中。支払いか注文の終了で自動で変わります。",
    "auto_sold": "売れました。委託者への支払いで自動で変わります。",
    "auto_returned": "委託者に返却済みです。",
    "auto_generic": "この状態は自動で変わります。",
    "confirm_title": "「{{stage}}」にしますか？",
    "confirm_consequence": "委託者のポータルにも新しい状態が表示されます。",
    "confirm": "変更"
  },
  "price": {
    "change": "価格の変更",
    "new_title": "新しい販売価格を提案",
    "new_intro": "委託者がポータルで新しい価格を承認します（または委託者が決めた日数が過ぎると自動で承認）。",
    "current": "今の価格",
    "minimum": "最低価格",
    "no_minimum": "設定なし",
    "new_price": "新しい価格",
    "reason": "理由",
    "below_min_warning": "最低価格より下です。自動では承認されません。",
    "how_it_works": "サイトの価格は、委託者が承認してから変わります。",
    "send": "委託者に送る",
    "sent": "送りました。委託者のポータルで確認されます。",
    "applied": "新しい価格で販売中です。",
    "open_title": "回答待ちの価格",
    "waiting_consignor": "委託者の回答待ちです。",
    "waiting_staff": "委託者がお店の回答を待っています。",
    "waiting_nobody": "回答するものはありません。",
    "proposed_by_staff": "お店の提案：",
    "proposed_by_consignor": "委託者の希望：",
    "counter_of": "委託者からの返答：",
    "below_min_note": "受付時に合意した最低価格より下です。",
    "needs_manager": "大きな値下げです。店長の承認が必要です。",
    "auto_on": "自動承認日：",
    "note": "メモ",
    "note_hint": "任意。回答と一緒に保存されます。",
    "approve": "この価格を承認",
    "approved": "承認しました。新しい価格で販売中です。",
    "decline": "お断りする",
    "declined": "お断りしました。",
    "withdraw": "提案を取り下げる",
    "withdrawn": "提案を取り下げました。",
    "close": "閉じる",
    "pending_line": "回答待ちの価格："
  },
  "prices": {
    "from": "今の価格",
    "to": "新しい価格",
    "waiting": "回答する人",
    "waiting_staff": "お店",
    "waiting_consignor": "委託者",
    "waiting_nobody": "なし",
    "since": "いつから",
    "status": "状態",
    "status_pending": "回答待ち",
    "status_countered": "委託者が金額で返答",
    "status_approved": "承認",
    "status_auto_approved": "自動承認",
    "status_rejected": "委託者が不承認",
    "status_expired": "期限切れ",
    "status_cancelled": "取り下げ",
    "view_open": "回答待ち",
    "view_countered": "委託者が返答"
  },
  "return": {
    "button": "委託者に返却",
    "confirm_title": "このカードを返却しますか？",
    "confirm_consequence": "サイトからすぐに下げます。古物台帳の払出は、手渡し・発送のときに記録します。",
    "confirm": "返却を始める",
    "started": "返却を始めました。サイトから下げました。",
    "open_panel": "カードを開いて返却してください。",
    "title": "返却 {{reference}}",
    "status": {
      "requested": "依頼あり。ショーケースから出してください。",
      "preparing": "ショーケースから出しています。",
      "ready": "準備完了。店頭で手渡しか発送してください。",
      "handed_over": "手渡し済み。",
      "handed_over_pending_inventory": "手渡し済み。在庫を更新中です。",
      "shipped": "発送済み。",
      "shipped_pending_inventory": "発送済み。在庫を更新中です。",
      "cancelled": "取り消し。"
    },
    "prepare": "出しています",
    "ready": "準備できました",
    "at_shop": "店頭で",
    "signature": "署名した返還受領書の写真",
    "hand_over": "手渡しました",
    "by_post": "発送で",
    "carrier": "配送会社",
    "tracking": "追跡番号",
    "ship": "発送しました",
    "sync": "在庫をもう一度更新",
    "slip": "返還受領書",
    "cancel": "返却をやめる",
    "cancel_consequence": "カードは元の状態に戻ります。",
    "saved": "保存しました。",
    "done_preparing": "出しています。",
    "done_ready": "準備完了。委託者に知らせました。",
    "done_handed_over": "手渡しました。古物台帳に記録しました。",
    "done_shipped": "発送しました。古物台帳に記録しました。",
    "done_cancelled": "返却をやめました。"
  },
  "requests": {
    "title": "委託の申し込み",
    "intro": "サイトから委託を申し込んだ方です。連絡してから、受け入れる（委託者＋受付を作成）かお断りします。",
    "reference": "番号",
    "name": "名前",
    "cards": "カード",
    "status_col": "状態",
    "received": "受信",
    "status": {
      "new": "新着",
      "contacted": "連絡済み",
      "accepted": "受け入れ",
      "rejected": "お断り",
      "converted": "委託者を作成済み"
    },
    "view_new": "新着",
    "view_contacted": "連絡済み",
    "load_failed": "この申し込みを読み込めませんでした。",
    "language": "言語",
    "asking": "希望価格",
    "notes": "お店のメモ",
    "note": "メモ",
    "note_hint": "申し込みと一緒に保存します（お客様には送りません）。",
    "accept": "受け入れて受付を準備",
    "contacted": "連絡しました",
    "reject": "お断りする",
    "reject_hint": "お断りすると、お客様の言語で丁寧なメールが送られます。",
    "saved": "保存しました。",
    "done_contacted": "連絡済みにしました。",
    "done_rejected": "お断りしました。メールを送ります。",
    "open_intake": "受付を開く",
    "convert_title": "申し込みを受け入れる",
    "convert_intro": "カードごとに種類・ランクA〜Dまたはグレード・合意価格を確認してください。本人確認と契約は受付のときに行います。",
    "convert": "委託者と受付を作る",
    "card_n": "{{n}}枚目"
  }
}
